"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCandid = exports.fromCandid = void 0;
const messageContent_1 = require("./messageContent");
const option_1 = require("./option");
const userId_1 = require("./userId");
function fromCandid(value) {
    const option = option_1.fromCandid(value);
    return option
        ? {
            chatId: option.chat_id,
            userId: userId_1.fromCandid(option.user_id),
            messageId: option.message_id,
            content: messageContent_1.fromCandid(option.content)
        }
        : null;
}
exports.fromCandid = fromCandid;
function toCandid(repliesTo) {
    const option = repliesTo
        ? {
            chat_id: repliesTo.chatId,
            user_id: userId_1.toCandid(repliesTo.userId),
            message_id: repliesTo.messageId,
            content: messageContent_1.toCandid(repliesTo.content)
        }
        : null;
    return option_1.toCandid(option);
}
exports.toCandid = toCandid;
